<ag-grid-angular
  class="ag-theme-alpine w-100 h-100"
  [gridOptions]="gridOptions"
  (gridReady)="onGridReady($event)"
></ag-grid-angular>
